import { useEffect } from "react";
import { LOCALE } from "./lang";

const SITE = process.env.REACT_APP_SITE_URL || "https://translinked.net";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
}

export function useSeo({ title, description, path, lang, alternates = [], noindex = false, image }) {
  useEffect(() => {
    if (!title) return undefined;
    document.title = title;
    document.documentElement.lang = lang;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", SITE + path);
    setMeta("property", "og:locale", (LOCALE[lang] || "es-ES").replace("-", "_"));
    setMeta("property", "og:image", SITE + (image || "/brand/og-image.jpg"));
    setMeta("name", "twitter:card", "summary_large_image");
    document.head.querySelectorAll("link[data-seo]").forEach((n) => n.remove());
    const add = (rel, href, hreflang) => {
      const l = document.createElement("link");
      l.rel = rel; l.href = SITE + href; l.dataset.seo = "1";
      if (hreflang) l.hreflang = hreflang;
      document.head.appendChild(l);
    };
    add("canonical", path);
    alternates.forEach((a) => add("alternate", a.path, a.lang));
    const xd = alternates.find((a) => a.lang === "es");
    if (xd) add("alternate", xd.path, "x-default");
    return undefined;
  }, [title, description, path, lang, noindex, image, JSON.stringify(alternates)]); // eslint-disable-line react-hooks/exhaustive-deps
}
